export const entregasColumns = [
  {
    id: 'consecutivo',
    label: 'Consecutivo',
    type: 'text',
    sortable: true
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    options: [
      { value: 'recibido', label: 'Recibido' },
      { value: 'pendiente_verificacion', label: 'Pendiente Verificación' },
      { value: 'verificado', label: 'Verificado' },
      { value: 'rechazado', label: 'Rechazado' },
      { value: 'entregado', label: 'Entregado' }
    ]
  },
  {
    id: 'empleado.nombre',
    label: 'Empleado',
    type: 'text',
    sortable: true
  },
  {
    id: 'empleado.cedula',
    label: 'Cédula',
    type: 'text',
    sortable: true
  },
  {
    id: 'empleado.area.nombre',
    label: 'Área',
    type: 'text',
    sortable: true
  },
  {
    id: 'cantidad_prendas',
    label: 'Total Prendas',
    type: 'number',
    sortable: true
  },
  {
    id: 'createdAt',
    label: 'Fecha Recepción',
    type: 'datetime',
    sortable: true
  },
  {
    id: 'opciones',
    label: 'Opciones',
    type: 'opciones',
    actions: [
      {
        key: 'preview',
        icon: 'Eye',
        tooltip: 'Generar vista previa',
        className: 'text-blue-600 hover:bg-blue-50'
      }
    ]
  }
];

export const columnsExcel = [
  { key: 'consecutivo', header: 'Consecutivo' },
  { key: 'estado', header: 'Estado' },
  { key: 'empleado.nombre', header: 'Empleado' },
  { key: 'empleado.cedula', header: 'Cédula' },
  { key: 'empleado.area.nombre', header: 'Área' },
  { key: 'casillero', header: 'Casillero' },
  { key: 'cantidad_prendas', header: 'Total Prendas' },
  { key: 'createdAt', header: 'Fecha Recepción' }
];

// Función para procesar los datos antes de mostrarlos en la tabla
export const processEntregaData = (entregas) => {
  console.log({entregas});
  return entregas.map(entrega => ({
    ...entrega,
    id: entrega._id || entrega.id,
    'empleado.nombre': entrega.empleado?.nombre + ' ' + entrega.empleado?.apellido || '',
    'empleado.cedula': entrega.empleado?.cedula || '',
    'empleado.area.nombre': entrega.empleado?.area?.nombre || 'Sin área',
    cantidad_prendas: entrega.cantidad_prendas || 0,
    casillero: entrega.casillero === 'N/A' ? 'Sin asignar' : entrega.casillero || 'Sin asignar',
    createdAt: entrega.createdAt ? new Date(entrega.createdAt).toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    }) : ''
  }));
};
